<template>
  <div>
    <Pane />

    <a-card class="container">
      <a-form-model layout="inline" @keyup.enter.native="query">
        <a-row>
          <a-col :span="22">
            <a-form-model-item>
              <a-input v-model="form.inventoryName" placeholder="盘点名称" />
            </a-form-model-item>
            <a-form-model-item>
              <a-select v-model="form.inventoryType" placeholder="盘点类型" style="width: 150px">
                <a-select-option
                  v-for="item in ['全面盘点', '部门盘点', '专项盘点']"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item>
              <a-select v-model="form.status" placeholder="盘点状态" style="width: 150px">
                <a-select-option
                  v-for="(item, index) in statusList"
                  :key="index"
                  :value="item.value"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item>
              <a-range-picker
                v-model="form.dateRange"
                :placeholder="['发起日期开始', '发起日期结束']"
              />
            </a-form-model-item>
            <a-form-model-item>
              <a-space>
                <a-button @click="query" type="primary">查询</a-button>
                <a-button @click="reset">重置</a-button>
              </a-space>
            </a-form-model-item>
          </a-col>

          <a-col :span="2">
            <div class="right" style="margin-top: 4px">
              <a-button
                v-if="$getPermission($route.path + '/add')"
                @click="$router.push($route.path + '/add')"
                type="primary"
                >新建</a-button
              >
            </div>
          </a-col>
        </a-row>
      </a-form-model>

      <Padding />

      <a-table
        bordered
        :dataSource="list"
        :loading="loading"
        @change="onChange"
        :pagination="{
          total,
          current,
          pageSize,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
      >
        <a-table-column title="盘点名称" data-index="inventoryName"> </a-table-column>
        <a-table-column title="盘点类型" data-index="inventoryType"> </a-table-column>
        <a-table-column title="盘点开始日期" data-index="startDate"> </a-table-column>
        <a-table-column title="盘点结束日期" data-index="endDate"> </a-table-column>
        <a-table-column title="盘点执行人" data-index="executorType"> </a-table-column>
        <a-table-column title="任务创建日期" data-index="createTime"> </a-table-column>
        <a-table-column title="盘点状态">
          <template slot-scope="text">
            <DataDictFinder
              dictType="asset_master_status"
              :dictValue="text.status"
              iconType="badge"
            />
          </template>
        </a-table-column>
        <a-table-column title="操作" align="right" width="120px">
          <template slot-scope="text">
            <a-space>
              <a
                href="#"
                @click.prevent="$router.push($route.path + '/edit?id=' + text.id)"
                v-if="$getPermission($route.path + '/edit')"
                >编辑</a
              >
              <a
                href="#"
                @click.prevent="$router.push($route.path + '/manage?id=' + text.id)"
                v-if="$getPermission($route.path + '/manage')"
                >管理</a
              >
              <a
                href="#"
                @click.prevent="deleteText(text)"
                style="color: #f5222d"
                v-if="$getPermission($route.path + '/edit')"
                >删除</a
              >
            </a-space>
          </template>
        </a-table-column>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import watermark from "@/mixins/watermark";
import request from "@/api/request";
import { mapGetters } from "vuex";

function fetchList(data) {
  return request({
    url: "/office-service/fixed/asset/inventory/master/list",
    data,
    method: 'post'
  });
}
function deleteCategory(id) {
  return request({
    url: "/office-service/fixed/asset/inventory/master/delete/" + id,
    method: 'post'
  });
}

export default {
  mixins: [watermark],

  data() {
    return {
      form: {},
      loading: false,
      current: 1,
      pageSize: 10,
      list: [],
      total: 0,
    };
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    typeList() {
      return this.findDataDict("fixed_asset_type");
    },
    statusList() {
      return this.findDataDict("asset_master_status");
    }
  },

  mounted() {
    this.getList();
  },

  methods: {
    deleteText(text) {
      this.$confirm({
        title: "删除确认",
        content: `确认删除 "${text.inventoryName}" 吗？`,
        onOk: () => {
          deleteCategory(text.id)
           .then(() => {
              this.getList();
            })
           .catch(() => {
              this.$message.error("删除失败");
            });
        },
      });
    },
    getList() {
      const { current, pageSize, form } = this;
      const {
        dateRange
      } = this.form;
      let startDateStart
      let startDateEnd
      if (Array.isArray(dateRange) && dateRange.length === 2) {
        startDateStart = dateRange[0].format("YYYY-MM-DD");
        startDateEnd = dateRange[1].format("YYYY-MM-DD");
      }
      this.loading = true;
      fetchList({
        pageNum: current,
        pageSize,
        startDateStart,
        startDateEnd,
        ...form,
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res.list)) {
            this.list = res.list;
            this.total = res.totalSize;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },

    query() {
      this.current = 1;
      this.getList();
    },
    reset() {
      this.form = {};
      this.current = 1;
      this.getList();
    }
  },
};
</script>